(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AllInclusivePropertySheetAddEdit',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		// disable send button if a field is changed
		$('.sheet-field').change(function disableSend() {
			if ($('.btn-send')) {
				$('.btn-send').prop('disabled', true);
				$('.save-message').show();
			}
		});

		// handle price includes taxes & fees being checked
		$('#allinclusivepropertysheetaddedit-includes_taxes_fees').change(function toggleTaxesFeesData() {
			var taxes_fees_included = $(this).prop('checked');

			// default to enabled
			$('.tax-fee-field').removeClass('disabled');
			$('.tax-fee-field').attr('disabled', false);

			if (taxes_fees_included === true) {
				// disable
				$('.tax-fee-field').addClass('disabled');
				$('.tax-fee-field').attr('disabled', true);

				priceRecalculate();
			} else {
				priceRecalculate();
			}
		});

		// handle price type field changing
		$('#allinclusivepropertysheetaddedit-price_type').change(function togglePriceData() {
			var price_type = $(this).val();

			// default to hidden/disabled
			$('.price-data').addClass('hidden');
			$('.price-field').addClass('disabled');
			$('.price-field').attr('disabled', true);

			if (price_type.length > 0) {
				// show/enable
				$('.price-data').removeClass('hidden');
				$('.price-field').removeClass('disabled');
				$('.price-field').attr('disabled', false);

				// trigger logic to enable/disable taxes & fees
				$('#allinclusivepropertysheetaddedit-includes_taxes_fees').trigger('change');
			} else {
				$('.price-field').val('');

				priceRecalculate();
			}
		});

		// handle number of categories changing
		$('#allinclusivepropertysheetaddedit-number_categories').change(function toggleCategoryData() {
			var num_categories = $(this).val(),
			    max_categories = $('#allinclusivepropertysheetaddedit-max_categories').val(),
			    i;

			$('.category-data').addClass('hidden');

			for (i = max_categories; i >= 1; i--) {
				$('.category-row-' + i).addClass('hidden');
			}

			if (num_categories.length > 0) {
				$('.category-data').removeClass('hidden');

				for (i = num_categories; i >= 1; i--) {
					$('.category-row-' + i).removeClass('hidden');
				}
			}

			// trigger logic to enable/disable price fields
			$('#allinclusivepropertysheetaddedit-price_type').trigger('change');
		});

		// handle vendor selection
		$('#allinclusivepropertysheetaddedit-vendor_id').change(function getProperties() {
			var vendor_id        = $(this).val(),
				$property_select = $('#allinclusivepropertysheetaddedit-all_inclusive_property_id'),
				$option;

			if (vendor_id.length > 0) {
				$property_select.prop('disabled', false);
				$property_select.empty();
				$option = $('<option>').text('Select Resort').attr('value', '');
				$property_select.append($option);

				Adzuki.Ajax.get('/AllInclusiveProperties/getPropertyList/' + vendor_id)
				.then(function getPropertiesSuccess(data) {
					var sorted_data = Adzuki.Sort.alphabeticValue(data);

					$.each(sorted_data, function parseShips(key, property) {
						var $option = $('<option>').text(property.value).attr('value', property.key);
						$property_select.append($option);
					});
				});
			} else {
				$property_select.empty();
				$property_select.prop('disabled', true);

				$option = $('<option>').text('Choose Supplier').attr('value', '');
				$property_select.append($option);
			}
		});

		$('#allinclusivepropertysheetaddedit-all_inclusive_property_id').change(function showDestinationGuideLink() {
			if ($(this).val() === '') {
				$('.destination-guide').addClass('hidden');
			} else {
				Adzuki.Ajax.get('/AllInclusivePropertySheets/checkForGuide/' + $(this).val())
				.then(function getPropertiesSuccess(data) {
					if (data.guide_id.length > 0) {
						$('.destination-guide').removeClass('hidden');
					} else {
						$('.destination-guide').addClass('hidden');
					}
				});
			}
		});

		// trigger category data show/hide
		$('#allinclusivepropertysheetaddedit-number_categories').trigger('change');

		$('.btn-send').prop('disabled', false);
		$('.save-message').hide();

		$('.price-field').change(function triggerPriceRecalculate() {
			priceRecalculate();
		});

		// handle category details link being click
		$('.toggle-category-details').click(function toggleDetails(e) {
			var $self        = $(this),
			    category_row = $self.data('category-row'),
			    action       = $self.data('action'),
			    container    = $self.data('container'),
			    field_key    = (category_row - 1);

			e.preventDefault();

			if (action === 'add') {
				// show field
				// hide add link
				$('.add-' + container + '-' + category_row).addClass('hidden');

				$('.category-' + container + '-container-' + category_row).slideToggle("fast", function slideBabySlide() {
					// enable the field
					$('#allinclusivepropertysheetaddedit-category_' + container + '-' + field_key).prop('disabled', false);

					// show container
					$('.category-' + container + '-container-' + category_row).removeClass('hidden');

					// show remove link
					$('.remove-' + container + '-' + category_row).removeClass('hidden');
				});
			} else {
				// hide field
				// hide remove link
				$('.remove-' + container + '-' + category_row).addClass('hidden');

				$('.category-' + container + '-container-' + category_row).slideToggle("fast", function slideBabySlide() {
					// hide container
					$('.category-' + container + '-container-' + category_row).addClass('hidden');

					// show add link
					$('.add-' + container + '-' + category_row).removeClass('hidden');

					// disable the field
					$('#allinclusivepropertysheetaddedit-category_' + container + '-' + field_key).prop('disabled', true);
				});
			}

		});

		// handle send button clicked
		$('.btn-send').click(function send(e) {
			var id = $(this).data('id');

			e.preventDefault();

			document.location =  Adzuki.base_uri + '/AllInclusivePropertySheets/send/' + id;
		});

		$('.clear-insurance').click(function clearInsurance(e) {
			e.preventDefault();

			Adzuki.Editor('#allinclusivepropertysheetaddedit-insurance', {
			init_instance_callback: function onEditorInit(_editor) {
				_editor.setContent('');
				},
			});
		});

		$('[name="form_component_data[AllInclusivePropertySheetAddEdit][include_live_pricing]"]').change(function toggleLivePricing()
		{
			var $num_categories = $('#allinclusivepropertysheetaddedit-number_categories'),
			    $price_type     = $('#allinclusivepropertysheetaddedit-price_type'),
			    $num_guests     = $('#allinclusivepropertysheetaddedit-number_guests'),
			    $num_nights     = $('#allinclusivepropertysheetaddedit-number_nights'),
			    $taxes_fees     = $('#allinclusivepropertysheetaddedit-includes_taxes_fees'),
			    num_rooms       = $('#allinclusivepropertysheetaddedit-num_rooms').val(),
			    is_live         = this.value === '1',
			    num_nights      = 1,
			    i, $category, $price;

			// toggle options (dates/rooms/pax)
			$form.find('.live-pricing-fields').toggleClass('hidden', !is_live);

			// live pricing does include taxes/fees
			$form.find('#allinclusivepropertysheetaddedit-includes_taxes_fees').prop('checked', is_live);

			if (is_live)
			{
				// set num categories to num of live room categories
				$num_categories
					.prop('disabled', true)
					.val($num_categories.data('live-num-categories'));

				$('<input type="hidden" data-type="num-categories">')
					.prop('name', $num_categories.prop('name'))
					.val($num_categories.val())
					.insertAfter($num_categories);

				$num_categories
					.data('name', $num_categories.prop('name'))
					.prop('name', '')
					.trigger('change');

				// set price as per-night
				$price_type
					.prop('disabled', true)
					.val('per_room');

				$('<input type="hidden" data-type="price-type">')
					.prop('name', $price_type.prop('name'))
					.val($price_type.val())
					.insertAfter($price_type);

				$price_type
					.data('name', $price_type.prop('name'))
					.prop('name', '')
					.trigger('change');

				$num_nights.val($num_nights.data('live-num-nights'));
				num_nights = $num_nights.val();
				$num_nights.prop('readonly', true);

				$num_guests.val($num_guests.data('live-num-guests'));
				$num_guests.prop('readonly', true);

				// taxes/fees always included
				$taxes_fees
					.prop('disabled', true)
					.val('1');

				$('<input type="hidden" data-type="taxes-fees-included">')
					.prop('name', $taxes_fees.prop('name'))
					.val($taxes_fees.val())
					.insertAfter($taxes_fees);

				$taxes_fees
					.data('name', $taxes_fees.prop('name'))
					.prop('name', '')
					.trigger('change');
			}
			else
			{
				// restore defaults
				$num_categories
					.prop('disabled', false)
					.prop('name', $num_categories.data('name'))
					.val('') // reset value first
					.find('option:selected').removeProp('selected')
					.trigger('change');

				$num_categories.siblings('input[data-type="num-categories"]').remove();

				$price_type
					.prop('disabled', false)
					.prop('name', $price_type.data('name'))
					.val('')
					.trigger('change');

				$price_type.siblings('input[data-type="price-type"]').remove();

				$num_nights.val('');
				$num_nights.prop('readonly', false);

				$num_guests.val('');
				$num_guests.prop('readonly', false);

				$taxes_fees
					.prop('disabled', false)
					.prop('name', $taxes_fees.data('name'))
					.trigger('change');

				$taxes_fees.siblings('input[data-type="taxes-fees-included"]').remove();
			}

			// update inputs
			for (i = 0; i <= parseInt($num_categories.find('option:last').val()); i++)
			{
				$category = $('#allinclusivepropertysheetaddedit-category_name-'+i);
				$category.val(is_live ? $category.data('live-name') : '');

				$price = $('#allinclusivepropertysheetaddedit-price-'+i);
				$price.val(is_live ? parseFloat($price.data('live-price') / num_nights).toFixed(2) : '');
				$price.prop('readonly', is_live);

				$('#allinclusivepropertysheetaddedit-number_rooms-'+i).val(is_live ? num_rooms : '');
			}

			priceRecalculate();
		});

		$([
			'#allinclusivepropertysheetaddedit-checkin_checkout',
			'#allinclusivepropertysheetaddedit-num_rooms',
			'#allinclusivepropertysheetaddedit-num_adults',
			'#allinclusivepropertysheetaddedit-num_children',
		].join(',')).change(function showRefreshButton() {
			$('.btn.refresh-live-pricing').removeClass('hidden');
		});

		$('#allinclusivepropertysheetaddedit-num_children').change(function addPaxFields()
		{
			var $fields = $form.find('.child-age');

			$fields
				.addClass('hidden')
				.find('select')
				.prop('disabled', true);

			if (this.value > 0) {
				$fields.slice(0, this.value)
					.removeClass('hidden')
					.find('select')
					.prop('disabled', false);
			}
		});

		$('.btn.refresh-live-pricing').click(function refreshLivePricing()
		{
			// this should just re-run search and refresh the page?
			var criteria = {
				include_live_pricing: '1',
				hotelbeds_code      : $('#allinclusivepropertysheetaddedit-hotelbeds_code').val(),
				checkin_checkout    : $('#allinclusivepropertysheetaddedit-checkin_checkout').val(),
				check_in            : $('#allinclusivepropertysheetaddedit-check_in').val(),
				check_out           : $('#allinclusivepropertysheetaddedit-check_out').val(),
				num_rooms           : $('#allinclusivepropertysheetaddedit-num_rooms').val(),
				num_adults          : $('#allinclusivepropertysheetaddedit-num_adults').val(),
				num_children        : $('#allinclusivepropertysheetaddedit-num_children').val(),
				child_ages          : [],
			}, i;

			event.preventDefault();

			if (criteria.num_children > 0) {
				for (i = 0; i < criteria.num_children; i++) {
					criteria['child_ages'].push($('#allinclusivepropertysheetaddedit-child_ages-'+i).val());
				}
			}

			$(this).addClass('disabled');

			Adzuki.Ajax.post('/AllInclusivePropertySheets/refreshLivePricing', criteria)
			.then(function reload() {
				window.location.reload();
			});
		});

		// pre-select "live" mode if necessary
		if ($('#allinclusivepropertysheetaddedit-include_live_pricing-1').prop('checked')) {
			$('#allinclusivepropertysheetaddedit-include_live_pricing-1').click().trigger('change');
		}
	};

	function priceRecalculate()
	{
		var num_categories = $('#allinclusivepropertysheetaddedit-number_categories').val();
		var selected_label = $('#allinclusivepropertysheetaddedit-price_type option:selected').text();
		var selected_val   = $('#allinclusivepropertysheetaddedit-price_type option:selected').val();
		var i, price, taxes, total, label;

		// if select isnt available, check hidden
		if (!selected_val) {
			selected_val = $('#allinclusivepropertysheetaddedit-price_type').val();
		}

		for (i=1;i <= num_categories;i++) {
			price = parseFloat($('#allinclusivepropertysheetaddedit-price-' + (i -1)).val());

			if ($('#allinclusivepropertysheetaddedit-taxes_fees-'+ (i -1)).hasClass('disabled')) {
				taxes = 0;
			} else {
				taxes = parseFloat($('#allinclusivepropertysheetaddedit-taxes_fees-' + (i -1)).val());
			}
			total = accounting.formatMoney(price + taxes);
			label = '<strong>Total:</strong> ' + total + ' ' + selected_label;

			if (selected_val.length > 0) {
				$('#calculated-value-' + i).html(label);
			} else {
				$('#calculated-value-' + i).html('');
			}
		}
	}

}(jQuery, window.Adzuki || {}));
